import { DependentFormInfoDTO } from '../../../dtos/forms.dtos';

class DependentFormInfo {
  dependentFormId!: string;
  description!: string;
  navigationButtonId!: string;
  navigationButtonText!: string;

  constructor(dependent_form_info: DependentFormInfoDTO) {
    const {
      dependentFormId,
      description,
      navigationButtonId,
      navigationButtonText
    } = dependent_form_info;
    this.dependentFormId = dependentFormId;
    this.description = description;
    this.navigationButtonId = navigationButtonId;
    this.navigationButtonText = navigationButtonText;
  }
}

export default DependentFormInfo;
